import { Attrs, MinzeElement } from 'minze'

export interface LvcLocationIcon {}

export class LvcLocationIcon extends MinzeElement {
  attrs: Attrs = [
    ['data-width', 24],
    ['data-height', 24],
  ]
  html = () => `
  <svg width="${this.dataWidth}" height="${this.dataHeight}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.0508 3.49586C14.8579 2.67225 13.2834 2.3103 11.4896 2.59712C9.66637 2.88864 8.39998 3.57001 7.6044 4.51983C6.81037 5.4678 6.4343 6.74408 6.50933 8.32778C6.6563 11.4297 8.53248 15.5876 12.1083 20.2631C17.4374 15.2774 18.9634 10.5608 18.3841 7.29586C18.0879 5.62629 17.2429 4.31896 16.0508 3.49586ZM19.3687 7.12116C20.0461 10.9387 18.1675 16.1282 12.3818 21.3705L11.9833 21.7315L11.6521 21.3079C7.81903 16.4048 5.6767 11.8839 5.51045 8.37511C5.42664 6.6062 5.8448 5.06323 6.83779 3.87772C7.82923 2.69406 9.34265 1.9277 11.3317 1.60966C13.3502 1.28692 15.1909 1.68693 16.619 2.67296C18.0478 3.65951 19.0296 5.20952 19.3687 7.12116Z" fill="#1E007D" stroke="#1E007D"/>
  <circle cx="12.5" cy="8.5" r="2.5" fill="#1E007D"/>
  </svg>
  `

  css = () => `
    
  `
}
